import { notification } from 'antd'
import axios from './axiosInstance'
import constants from '../constants'
import { handleErrors, definedErrorCodes } from '../helpers'

export default function init() {
  console.log('extensions init')
}

export async function list(app, type = 'all') {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  let URL = `${constants.customerDomain}regions/${app.region}/extensions?per_page=50`
  if (type === 'installed')
    URL = `${constants.customerDomain}/apps/${app.id}/extensions?per_page=50`
  return axios
    .get(`${URL}`, {
      headers: { Authorization: `Bearer ${ccBearerToken}` },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorMsgs = handleErrors('')
      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code, 'extensions_list')
      ) {
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      }
      return error.response.data
    })
}

export async function search(app, searchText, type = 'all') {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  let URL = `${constants.customerDomain}regions/${app.region}/extensions?per_page=50`
  if (type === 'installed')
    URL = `${constants.customerDomain}/apps/${app.id}/extensions?per_page=50`
  return axios
    .get(`${URL}?searchKey=${searchText}`, {
      headers: { Authorization: `Bearer ${ccBearerToken}` },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function changeExtensionStatus(id, app, type = 'all') {
  let post

  const ccBearerToken = localStorage.getItem('ccBearerToken')
  const URL = `${constants.customerDomain}apps/${app.id}/extensions`

  if (type === 'installed' || type === 'enabled') {
    post = {
      disabled: [id],
    }
  } else {
    post = {
      enabled: [id],
    }
  }

  return axios
    .post(`${URL}`, post, {
      headers: { Authorization: `Bearer ${ccBearerToken}` },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errResponse = { data: 'Error occurred. Please contact CometChat Team if error persists.' }

      if (error.response) {
        errResponse = error.response.data
        if (
          error.response &&
          error.response.data !== undefined &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          let errorMsgs = handleErrors('')
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
      }
      return errResponse
    })
}

export async function removeExtension(id, app) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')

  const URL = `${constants.customerDomain}apps/${app.id}/extensions`

  return axios
    .delete(`${URL}`, {
      headers: { Authorization: `Bearer ${ccBearerToken}` },
      data: {
        ids: [id],
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      if (
        error.response &&
        error.response.data !== undefined &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        let errorMsgs = handleErrors('')
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      }
      return error.response.data
    })
}

export async function disableExtension(id, app) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  const URL = `${constants.customerDomain}apps/${app.id}/extensions`

  const post = {
    disabled: [id],
  }

  return axios
    .post(`${URL}`, post, {
      headers: { Authorization: `Bearer ${ccBearerToken}` },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
